import { IoIosArrowForward } from "react-icons/io";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { ErrorText } from "../../atoms";
import { Grid } from "@mui/material";

const VariantTitle = ({ variant }) => {
  const { option1, option2, option3 } = variant;
  let optionTitle = `${option1}`;
  if (option2) {
    optionTitle = `${option1}, ${option2}`;
  }
  if(option3) {
    optionTitle = `${option1}, ${option2}, ${option3}`;
  }
  return <h5>{`${optionTitle}`}</h5>;
};

const VariantItem = ({ onClick, variant, error, isService }) => {
  const { inventoryQuantity, price, weight } = variant;
  const className = `variant-item ${
    error ? "error-border" : ""
  } d-flex w-100 justify-content-between text-start`;
  const errorArr = Object.values(error || {}).map((err) => err.message);
  return (
    <>
      <button onClick={onClick} className={className}>
        {/* <div className="variant-img"></div> */}
        <div className="w-100 px-2 h-100">
          <VariantTitle variant={variant} />
          <Grid justifyContent={"space-between"}  container >
            <Grid item md={'auto'}>{price ? <span >{`£ ${price}`}</span> : <span >{`£ ${0}`}</span>}</Grid>
            { !isService && <Grid item md={'auto'}> {inventoryQuantity ? (
              <span >{inventoryQuantity} in stock</span>
            ) : <span>0 in stock</span>}</Grid>}
           {weight && !isService ? <Grid item md={'auto'}><span >{weight}kg</span></Grid> : ""}
          </Grid> 
          
        </div>
        <div className="d-flex align-self-stretch align-items-center">
          <IoIosArrowForward size={20} color="gray" />
        </div>
      </button>
      {errorArr.map((err, index) => (
        <ErrorText key={`${err}-${index}`} text={"*" + err} />
      ))}
    </>
  );
};

export default VariantItem;
